import { useGoogleAnalytics } from '../hooks/useGoogleAnalytics';
import { useGoogleAdSense } from '../hooks/useGoogleAdSense';

export default function AnalyticsWrapper({ children }) {
  // Initialize Google Analytics and AdSense
  useGoogleAnalytics();
  useGoogleAdSense();

  return children;
}